import {useMemo} from "react";

export default function Pagination({setPage, page, maxPage, quantity, setQuantity}) {
	const hasNextPage = useMemo(() => {
		return page < maxPage;
	}, [maxPage, page]);

	const hasPreviousPage = page > 0;

	return (
		<div className={"d-flex justify-content-between align-items-center gap-2"}>
			<div className={"d-flex flex-shrink-0"}>
				<button type={"button"} disabled={!hasPreviousPage} className={"btn btn-outline-dark btn-sm"} onClick={evt => {
					setPage(0);
				}}>&lt;&lt;</button>
				<button type={"button"} disabled={!hasPreviousPage} className={"btn btn-outline-dark btn-sm ms-1"} onClick={evt => {
					setPage(prev => {
						return prev - 1;
					});
				}}>&lt;</button>
			</div>
			<div className={"flex-fill"} style={{maxWidth: "10rem"}}>
				<select className={"form-select form-select-sm"} value={quantity} onChange={evt => {
					setQuantity(Number(evt.target.value));
				}}>
					<option value="25">25 / page</option>
					<option value="50">50 / page</option>
					<option value="100">100 / page</option>
				</select>
			</div>
			<div className={"d-flex flex-shrink-0"}>
				<button type={"button"} disabled={!hasNextPage} className={"btn btn-outline-dark btn-sm"} onClick={evt => {
					setPage(prev => {
						return prev + 1;
					});
				}}>&gt;</button>
				<button type={"button"} disabled={!hasNextPage} className={"btn btn-outline-dark btn-sm ms-1"} onClick={evt => {
					setPage(maxPage);
				}}>&gt;&gt;</button>
			</div>
		</div>
	)
}
